export type LogNotePart = { type: 'text'; value: string } | { type: 'method'; value: string }

export const parseLogNote = (note?: string | null): LogNotePart[] => {
  if (!note) return []

  return note.split('|').map(part => {
    part = part.trim()

    if (part.startsWith('Method:')) {
      return {
        type: 'method',
        value: part.substring('Method:'.length).trim(),
      }
    }

    return {
      type: 'text',
      value: part,
    }
  })
}
